import Locale from "@/helper/locale/Locale";
export default {
    data: function () {
        return {
            lbl: Locale.getLbl(),
        };
    },
    methods: {
        errorApi: function (err, useAlertBottom = false, opts = {}) {
            var alertMsg = '';
            if (err.id != null) {
                switch (err.id) {
                    case 400:
                    case 401:
                    case 1427:
                        alertMsg = this.lbl.redeem_button.campaignPeriodInvalid;
                        break;
                    case 2078:
                    case 2122:
                        alertMsg = err.message;
                        break;
                    case 1:
                        alertMsg = this.lbl.redeem_button.soldOut;
                        break;
                    case 2:
                        alertMsg = this.lbl.redeem_button.maxPerPerson;
                        break;
                    case 1403:
                        alertMsg = this.lbl.redeem_button.conditionIsInvalid;
                        break;
                    case 1409:
                        alertMsg = this.lbl.redeem_button.campaignExpired;
                        break;
                    case 412:
                        alertMsg = "Token invalid";
                        break;
                    default:
                        alertMsg = err.message;
                }
            } else {
                alertMsg = "Network connection error!";
            }

            if (useAlertBottom) {
                let modal = null
                if (this.alertBottomModal != null) {
                    modal = this.alertBottomModal
                } else if (this.modalController.alertBottomModal != null) {
                    modal = this.modalController.alertBottomModal
                }

                if (modal != null) {
                    modal.clearModal()
                    if (opts.title != null) {
                        modal.setTitle(opts.title)
                    }
                    if (typeof opts.onClose == "function") {
                        modal.onClose(opts.onClose)
                    }
                    modal.setMsg(alertMsg).show()
                } else {
                    // fallback
                    alert(alertMsg)
                }
            } else {
                if (this.alertModal != null) {
                    this.alertModal.clearModal()
                        .setMsg(alertMsg)
                        .show();
                } else if (this.modalController.alertModal != null) {
                    this.modalController.alertModal.clearModal()
                        .setMsg(alertMsg)
                        .show();
                }
            }
        },
    },
}
